import React, {useState}  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../style/constants.js';
import Grid from '@material-ui/core/Grid';
import {MagnetoBusiness, MagnetoKing, MagnetoHero} from '../../../components/svgs/magneto-lito';
import Plus from '../../../components/svgs/plus';
import InnerLinkButton from '../../../components/svgs/buttons/InnerLinkButton.js';
import { Link } from 'gatsby';
import Ribbon from '../../../components/svgs/ribbon';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    padding: 30,
    [theme.breakpoints.down('md')]: {
      padding: 15,
      [theme.breakpoints.down('sm')]: {
        padding: 5,
        [theme.breakpoints.down('xs')]: {
          padding: 2.5,
          marginBottom: 30
        },
      },
    },
    '& > div': {
      position: 'relative',
      height: '100%',
      boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.25)',
      borderRadius: 10,
      background: colors.WHITE,
      zIndex: 2,
    },
    '& > svg': {
      transition: 'transform 0.75s',
      position: 'absolute',
      zIndex: 1,
      height: 260,
      [theme.breakpoints.down('md')]: {
        height: 210,
        [theme.breakpoints.down('sm')]: {
          height: 150,
          [theme.breakpoints.down('xs')]: {
            height: 100,
            zIndex: 3,
          },
        },
      },
    },
    '& h2': {
      textAlign: 'center',
      color: colors.WHITE,
      '& sup': {
        fontSize: '50%',
        verticalAlign: 'top',
        lineHeight: 1.75
      },
      '& span': {
        fontSize: '50%',
        marginLeft: 5
      }
    },
    '& h4': {
      textAlign: 'center',
      color: colors.WHITE,
    }
  },
  title: {
    padding: '30px 15px!important',
    width: '100%',
    boxSizing: 'border-box',
    '& > svg': {
      width: '1.75em',
      height: '1.75em',
      marginRight: 10,
      [theme.breakpoints.down('sm')]: {
        marginRight: 8,
        [theme.breakpoints.down('xs')]: {
          marginRight: 5,
        },
      },
    }
  },
  inclusions: {
    padding: '30px 0',
    '& > *': {
      padding: '0 15px'
    },
    '& button': {
      marginTop: 30
    },
    '& > ul > :first-child': {
      marginTop: 0,
    },
    '& > ul > li': {
      fontSize: '1.375em',
      fontWeight: 500,
      paddingLeft: 15,
      position: 'relative',
      color: colors.DARK_GREY,
      marginTop: 30,
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 'calc(1.375em/2 - 7.5px)',
        width: 7.5,
        height: 7.5,
        borderRadius: '50%',
      },
      '& a': {
        color: colors.DARK_GREY,
        textDecoration: 'underline'
      }
    }
  },
  ribbon: {
    height: 120,
    position: 'absolute',
    top: 70,
    right: -27,
    transform: 'rotate(-15deg)',
    [theme.breakpoints.down('md')]: {
      height: 90,
      [theme.breakpoints.down('sm')]: {
        height: 70,
        right: -20,
        [theme.breakpoints.down('xs')]: {
          height: 90,
        },
      },
    },
  }
}));

const Plan = (props) => {
  const [active, setActive] = useState(false);

  const renderIcon = () => {
    if (props.index === 0) {
      return <MagnetoBusiness className={active === true ? "active" : "inactive"}/>
    }
    if (props.index === 1) {
      return <MagnetoKing className={active === true ? "active" : "inactive"}/>
    }
    if (props.index === 2) {
      return <MagnetoHero className={active === true ? "active" : "inactive"}/>
    }
  }

  const renderTitle = () => {
    if (props.plan.node.name === "Simple") {
      return (
        <>
          <h2>Simple</h2>
        </>
      )
    }
    if (props.plan.node.name === "+Simple") {
      return (
        <>
          <Plus color={colors.WHITE}/>
          <h2>Simple</h2>
        </>
      )
    }
    if (props.plan.node.name === "++Simple") {
      return (
        <>
          <Plus color={colors.WHITE}/>
          <Plus color={colors.WHITE}/>
          <h2>Simple</h2>
        </>
      )
    }
  }
  const renderInclusions = () => {
    return props.plan.node.inclusions.map((inclusion, index) => {
      return (
        <li key={index}>{inclusion}</li>
      );
    });
  };

  const classes = useStyles();
  return (
    <Grid onMouseEnter={() => setActive(true)} onMouseLeave={() => setActive(false)} className={classes.wrapper} item xs={12} sm={4}>
      {renderIcon()}
      <Grid container justifyContent='space-between' direction='column'>
        <Grid>
          <Grid className={classes.title} container justifyContent='center' alignItems='center'>
            {renderTitle()}
          </Grid>
          <Grid className={classes.inclusions}>
            <ul>
              {renderInclusions()}
            </ul>
          </Grid>
          {props.index === 1 ? <Ribbon className={classes.ribbon}/> : ""}
        </Grid>
        <Grid className={classes.inclusions} container direction='column' alignItems='center'>
          <div className={classes.title}>
            <h2>{props.lang === 'en-CA' ? '$' : ''}{props.plan.node.price}{props.lang === 'en-CA' ? '' : <sup>$</sup>}<span>{props.lang === 'en-CA' ? '/month' : '/mois'}</span></h2>
            <h4>{props.lang === 'en-CA' ? 'per screen' : 'par écran'}</h4>
          </div>
          <Link to={props.lang === 'en-CA' ? '/en/contact-us' : '/nous-parler'}><InnerLinkButton text={props.lang === 'en-CA' ? 'Free trial' : 'Essai gratuit'} /></Link>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Plan;